export default `# Project Detail

The project detail page is your central hub for managing all aspects of a project. Use the sidebar to navigate between modules.

---

## Sidebar Sections

### Prep

- **Engagement Planner** — Configure your engagement approach and generate structured plans with workshops and agendas
- **Customer Research** — Search public data sources and build knowledge graphs from external research
- **Project Graph** — Interactive knowledge graph connecting all entities from research, sessions, and requirements. Visualise relationships between personas, user stories, decisions, and more
- **Knowledge Base** — Upload and manage reference documents that provide context to AI during sessions

### Ideate

- **Ideation** — Collect, discuss, and prioritise AI use case ideas

### Delivery

- **Requirements** — View and manage personas and user stories extracted from sessions
- **Tasks** — Create and track multi-agent async tasks for research, analysis, and prototyping
- **Build with AI** — Generate code scaffold bundles using session context, requirements, and design files

### Manage

- **Outputs** — Browse generated outputs from workflows and builds
- **File Browser** — View all project files and assets
- **LLM Costs** — Track AI execution costs across all sessions in this project
- **Access Control** — Manage which team members can access this project and their permission levels

---

## Sessions

The sidebar lists all sessions linked to this project with status indicators:

| Indicator | Meaning |
|-----------|---------|
| Green dot | Session is live |
| Amber dot | Session is pending |
| Gray dot | Session has ended |

Click **+ New Session** to create a session within this project's context.

---

## Project Actions

Use the three-dot menu in the top bar to:

- **Archive Project** — Hide from the active projects list
- **Delete Project** — Permanently remove the project and all linked data

---

## Tips

- **Follow the workflow** — The sidebar is organised as Prep → Ideate → Delivery → Manage, which mirrors a typical project lifecycle
- **Build context first** — Upload documents to the Knowledge Base and run Customer Research before starting sessions, so avatars have richer context
- **Check the graph regularly** — The Project Graph accumulates insights across sessions, often surfacing patterns not obvious from individual sessions`;
